import { render, staticRenderFns } from "./manage-board.vue?vue&type=template&id=073faa70"
import script from "./manage-board.vue?vue&type=script&lang=js"
export * from "./manage-board.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports